import { createAsyncThunk } from '@reduxjs/toolkit';

import { IGroup, IGroupDeleteVerficationData } from '.';
import { TSubscriptionPlanStatuses } from '../SubscriptionPlansSlice';
import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';

export type TAdminCreateGroup = {
  name: IGroup['name'];
  status: IGroup['status'];
  reschedule: IGroup['reschedule'];
  cancellation: IGroup['cancellation'];
  oneTimePayment: IGroup['oneTimePayment'];
  flexiblePlan: IGroup['flexiblePlan'];
  subscriptionPlan: IGroup['subscriptionPlan'];
  premiumAccess: IGroup['premiumAccess'];
  premiumAccessStartDate?: IGroup['premiumAccessStartDate'];
  premiumAccessEndDate?: IGroup['premiumAccessEndDate'];
  flexiblePlanCriteria?: IGroup['flexiblePlanCriteria'];
  flexiblePlans?: string[];
  subscriptionPlanCriteria?: IGroup['subscriptionPlanCriteria'];
  subscriptionPlans?: string[];
  appLogoPath?: IGroup['appLogoPath'];
};

export type TAdminGetGroups = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  statuses?: TSubscriptionPlanStatuses[];
};

export type TAdminUpdateGroup = {
  id: string;
  name: IGroup['name'];
  status: IGroup['status'];
  reschedule: IGroup['reschedule'];
  cancellation: IGroup['cancellation'];
  oneTimePayment: IGroup['oneTimePayment'];
  flexiblePlan: IGroup['flexiblePlan'];
  subscriptionPlan: IGroup['subscriptionPlan'];
  premiumAccess: IGroup['premiumAccess'];
  premiumAccessStartDate?: IGroup['premiumAccessStartDate'];
  premiumAccessEndDate?: IGroup['premiumAccessEndDate'];
  flexiblePlanCriteria?: IGroup['flexiblePlanCriteria'];
  flexiblePlans?: string[];
  subscriptionPlanCriteria?: IGroup['subscriptionPlanCriteria'];
  subscriptionPlans?: string[];
  appLogoPath?: IGroup['appLogoPath'];
};

const apiDataProvider = new APIDataProvider();

const adminGetGroupsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  statuses,
}: TAdminGetGroups) => {
  let path = `${AdminApiPaths.adminGroups}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (statuses) {
    path += `&statuses=${statuses}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IGroup>>
  >(path);

  return response.data;
};

export const adminCreateGroup = createAsyncThunk(
  '/admin/groups/create',
  async (data: TAdminCreateGroup) => {
    const path = `${AdminApiPaths.adminGroups}`;

    const response = await apiDataProvider.post<TApiResponse<IGroup>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateGroup = createAsyncThunk(
  '/admin/groups/update',
  async (data: TAdminUpdateGroup) => {
    const path = `${AdminApiPaths.adminGroups}/${data.id}`;

    const response = await apiDataProvider.put<TApiResponse<IGroup>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteGroup = createAsyncThunk(
  '/admin/groups/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminGroups}/${id}`;

    const response = await apiDataProvider.delete<TApiResponse<IGroup>>(path);

    return response.data;
  }
);

export const adminVerifyGroupDelete = createAsyncThunk(
  '/admin/groups/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminGroups}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IGroupDeleteVerficationData>
    >(path);

    return response.data;
  }
);

export const adminGetGroups = createAsyncThunk(
  '/admin/groups/list',
  adminGetGroupsModule
);
